var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDumbbell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40,98.29c1,0,1.79.38,1.79.85v19.78c0,.47-.8.86-1.79.86H32.08c-1,0-1.8-.39-1.8-.86V99.14c0-.47.8-.85,1.8-.85ZM54.88,72a2.71,2.71,0,0,1,2.43,2.93v68.29a2.73,2.73,0,0,1-2.43,3H44.22a2.74,2.74,0,0,1-2.43-3V74.88A2.72,2.72,0,0,1,44.22,72ZM78,59.67a3.87,3.87,0,0,1,3.83,3.91v90.9A3.87,3.87,0,0,1,78,158.39H61.14a3.88,3.88,0,0,1-3.83-3.91V63.58a3.87,3.87,0,0,1,3.83-3.91Zm101.24,60.11c-1,0-1.79-.39-1.79-.86V99.14c0-.47.81-.85,1.79-.85h7.92c1,0,1.81.38,1.81.85v19.78c0,.47-.81.86-1.81.86Zm-14.88,26.34a2.74,2.74,0,0,1-2.43-3V74.88A2.72,2.72,0,0,1,164.37,72H175a2.71,2.71,0,0,1,2.42,2.93v68.29a2.73,2.73,0,0,1-2.42,3Zm-23.12,12.27a3.88,3.88,0,0,1-3.84-3.91V63.58a3.88,3.88,0,0,1,3.84-3.91h16.86a3.87,3.87,0,0,1,3.83,3.91v90.9a3.87,3.87,0,0,1-3.83,3.91Zm-58.9-38.07h54.56m-54.56-22h54.56"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDumbbell);
export default __webpack_public_path__ + "static/media/DUMBBELL.34b56372230ac311f958710bbac7f862.svg";
export { ForwardRef as ReactComponent };